module.exports = __webpack_public_path__ + "static/img/CV.3a4bffe2.svg";